import { render } from "./AppHeaderMobile.vue?vue&type=template&id=504c76fe&scoped=true"
import script from "./AppHeaderMobile.vue?vue&type=script&lang=js"
export * from "./AppHeaderMobile.vue?vue&type=script&lang=js"

import "./AppHeaderMobile.vue?vue&type=style&index=0&id=504c76fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504c76fe"]])

export default __exports__